import _ from 'lodash'

export function formatNumber (value) {
  return Number(value).toLocaleString()
}

export function formatNumberByLocale (value, locale) {
  return Number(value).toLocaleString(locale)
}

export function skeletorData (data, optional = {}) {
  _.map(data, (e) => {
    return _.extend(e, { toggle: false, level: 1, space: '' }, optional)
  })

  return data
}

export function skeletorDataParent (data, parentId, parentLevel, optional) {
  _.map(data, (e) => {
    let createSpace = '&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp'.repeat(parentLevel)
    return _.extend(e, { parentId: parentId, space: createSpace, level: parentLevel + 1 }, optional)
  })

  return data
}

export function fallbackCopyTextToClipboard (text) {
  var textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    var successful = document.execCommand('copy')
    var msg = successful ? 'successful' : 'unsuccessful'
    console.log('Fallback: Copying text command was ' + msg)
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }

  document.body.removeChild(textArea)
}

export function copyTextToClipboard (text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text).then(function () {
    console.log('Async: Copying to clipboard was successful!')
  }, function (err) {
    console.error('Async: Could not copy text: ', err)
  })
}

export function applyNumberStyle (number) {
  let style = {
    color: '#A94442'
  }
  if (parseInt(number) >= 0) {
    style = {
      color: '#3C763D'
    }
  }

  return style
}

export function randomInteger (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export function randomString (length) {
  let chars = 'abcdefghijklmnopqrstufwxyzABCDEFGHIJKLMNOPQRSTUFWXYZ1234567890'
  let pwd = _.sampleSize(chars, length || 12) // lodash v4: use _.sampleSize
  return pwd.join('')
}
